<template>
  <div class="growthModelManagement-page" style="background-color: #fff">
    <div class="all-content-container">
      <div class="content-title-container">
        <div style="height: 40px">
          <div class="content-title-top">
            <h3>作物肥料模型</h3>
          </div>
          <el-button style="
              width: 130px;
              display: inherit;
              float: right;
              margin-top: -30px;
              margin-right: 10px;
            " @click="handleAdd" size="small" type="primary">+添加作物肥料模型</el-button>
        </div>
      </div>
      <div class="growthModelCard" v-loading="isLoading">
        <el-row :gutter="20">
          <el-col :span="8" v-for="(item, index) in tableData" :key="index">
            <div class="grid-content bg-purple" style="border: 1px solid #d8d8d8; border-radius: 5px">
              <div class="growth-titile-container">
                <h5>{{ item.name }}</h5>
                <button @click="handleDel(item.id)">删除</button>
                <button class="btnEditC" @click="handleEdit(item.id)">
                  编辑
                </button>
                <button class="btnEditC" @click="handleSet(item)">配置</button>
                <button class="btnEditC" @click="handleAuthorize(item)">
                  授权
                </button>
                <!-- <button class="btnEditC" style="width: 80px" @click="handleUse(item)">
                  使用记录
                </button> -->
              </div>
              <div class="growth-content-container">
                <div class="growth-content-left">
                  <img :src="item.image" alt />
                </div>
                <div class="growth-content-right">
                  <p>
                    <span>修改人：</span>{{ item.updateName }}
                  </p>
                  <!-- <p :title="item.updateTime">
                    <span class="over_text1">修改时间：</span>{{ item.updateTime }}
                  </p> -->
                  <!-- <p :title="item.breed">
                    <span>描述：</span>{{ item.remark }}
                  </p> -->
                </div>
              </div>
            </div>
          </el-col>
          <div class="empty-box" v-if="tableData.length == 0">
            <img :src="empty_img" />
          </div>
        </el-row>
      </div>
      <div class="pagination-content-container" style="">
        <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" :total="total"></el-pagination>
      </div>
    </div>
    <el-dialog :title="addEditTitle" :visible.sync="addEditIsDialog" :before-close="handleCancel" width="600px" center style="z-index: 10000">
      <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="图片：" prop="image">
              <UploadImg para="image" @setImg="setImg" :imgUrl="ruleForm.image" width="100" height="100"></UploadImg>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称：" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入名称" clearable maxlength="50" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UploadImg from '@/components/upload/UploadImg.vue'

export default {
  components: { UploadImg },
  data() {
    return {
      isLoading: true,
      empty_img: require('../../assets/img/timg.jpg'),
      currentPage: 1, //第几页，默认1
      pageSize: 6, //默认展示多少条，默认10
      total: 0,
      tableData: [],
      ruleForm: {
        // 添加编辑弹窗表单字段
        id: '',
        image: '',
        name: '',
        breed: '',
        features: '',
        growthCycle: '',
        harvest: ''
      },
      rules: {
        // 添加编辑弹窗表单规则
        image: [
          {
            required: true,
            message: '请上传图片',
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          }
        ],
        breed: [
          {
            required: true,
            message: '请输入品种',
            trigger: 'blur'
          }
        ],
        features: [
          {
            required: true,
            message: '请输入特性',
            trigger: 'blur'
          }
        ],
        growthCycle: [
          {
            required: true,
            message: '请输入周期',
            trigger: 'blur'
          }
        ],
        harvest: [
          {
            required: true,
            message: '请输入产量',
            trigger: 'blur'
          }
        ]
      },
      addEditTitle: '添加作物肥料模型', // 添加编辑弹窗标题
      addEditId: '', // 添加编辑ID
      addEditIsDialog: false // 添加编辑弹窗是否显示
    }
  },
  created() {
    // 查询
    this.handleSearch()
  },
  methods: {
    // 分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getGrowthModelFertilizerList()
    },
    // 查询
    handleSearch() {
      this.currentPage = 1
      this.getGrowthModelFertilizerList()
    },
    // 查询全部生长模型列表
    getGrowthModelFertilizerList() {
      this.$api.growthModel
        .getGrowthModelFertilizerList({
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          groupId: '',
          name: ''
        })
        .then((res) => {
          this.isLoading = false
          if (res.code == 200) {
            this.tableData = res.data
            this.total = res.count
          }
        })
    },
    // 删除
    handleDel(id) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.growthModel.delGrowthModelFertilizer(id).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleSearch()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 编辑
    handleEdit(id) {
      this.addEditIsDialog = true
      this.addEditTitle = '编辑作物肥料模型'
      this.addEditId = id

      // 获取详情
      this.$api.growthModel.getGrowthModelFertilizer({ id: id }).then((res) => {
        if (res.code == 200) {
          this.ruleForm = res.data
        }
      })
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true
      this.addEditTitle = '添加作物肥料模型'
      this.addEditId = ''
    },
    // 取消
    handleCancel() {
      this.$refs['ruleForm'].resetFields()
      this.addEditIsDialog = false
    },
    // 保存
    handleSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$api.growthModel.saveGrowthModelFertilizer(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleCancel()
              this.handleSearch()
            }
          })
        }
      })
    },
    // 配置生长模型阶段-时间-数据
    handleSet(row) {
      this.$router.push({
        name: `growthModelGrowthFertilizer`,
        query: {
          modelFertilizerId: row.id,
          growthModelName: row.name
        }
      })
    },
    // 授权
    handleAuthorize(row) {
      this.$router.push({
        name: `growthModelFertilizerUser`,
        query: {
          modelFertilizerId: row.id,
          growthModelName: row.name
        }
      })
    },
    // 使用记录
    handleUse(row) {
      this.$router.push({
        name: `growthModelUserLog`,
        query: {
          modelFertilizerId: row.id
        }
      })
    },
    // 上传图片
    setImg(url) {
      this.ruleForm.image = url
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/growthModelManagement.scss';

li {
  padding-left: 15px;
}
</style>